export class AssetLocationMeasurement {
	id: string;
	deviceId: string;
	locationId: string;
	data: any = {};
	frequency: number;
	timestamp: Date;
	rssi: number;
	lsnr: number;
}